import {
  addFbqTrackToWindow,
  fbqAddScript,
  fbqSetupBusinessTracking,
  fbqSetupTracking,
} from 'utils/analytics/fbq';
import { getApp, getFacebookPixelDetailsSelector } from 'selectors/appSelector';
import { useConsentRestrictedScripts } from 'hooks/useConsentRestrictedScripts';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';

/**
 * Adds the Facebook Pixel script and sets up tracking for Tock + customer properties
 * CAUTION: Execution order in this file is very important to allow proper script loading prior to
 * initializing properties and / or sending pageviews and events
 */
export const FacebookPixel: React.FC = () => {
  const { fastRoutingBetweenContext } = useSelector(getApp);
  const { facebookPixelId, businessFacebookPixelId, businessFacebookBusinessPixelId } = useSelector(
    getFacebookPixelDetailsSelector
  );
  const { scriptAdded, setScriptAdded, consentLevelAdvertising } = useConsentRestrictedScripts();
  const [businessPropertyInitialized, setBusinessPropertyInitialized] = useState(false);

  React.useEffect(() => {
    if (consentLevelAdvertising) {
      // add script to page
      if (!scriptAdded) {
        fbqAddScript(facebookPixelId, businessFacebookPixelId);
        fbqSetupTracking(facebookPixelId);
      }

      if (
        (businessFacebookPixelId || businessFacebookBusinessPixelId) &&
        !businessPropertyInitialized
      ) {
        // setup business tracking
        fbqSetupBusinessTracking(
          businessFacebookPixelId,
          businessFacebookBusinessPixelId,
          fastRoutingBetweenContext
        );
        setBusinessPropertyInitialized(true);
      }

      // Second !scriptAdded block necessary to ensure that business property is initialized (if needed) prior to executing initial pageview
      if (!scriptAdded) {
        const fbqTrack = addFbqTrackToWindow(
          fastRoutingBetweenContext,
          facebookPixelId,
          businessFacebookPixelId,
          businessFacebookBusinessPixelId
        );
        setScriptAdded(true);
        if (BROWSER) {
          fbqTrack('trackSingle', 'PageView');
        }
      }

      window.fbq('consent', 'grant');
    } else if (window.fbq) {
      window.fbq('consent', 'revoke');
    }
  }, [
    consentLevelAdvertising,
    facebookPixelId,
    businessFacebookPixelId,
    businessFacebookBusinessPixelId,
    fastRoutingBetweenContext,
    scriptAdded,
    setScriptAdded,
    businessPropertyInitialized,
  ]);

  return null;
};
